import { useRef, useState } from "react";
import PengisianMinyakDelete from "./pengisian-minyak-delete";
import PengisianMinyakEdit from "./pengisian-minyak-edit";
import PengisianMinyakList from "./pengisian-minyak-list";
import { ConfirmDialog } from "primereact/confirmdialog";

const PengisianMinyakMain = (props, { className }) => {
  const listRef = useRef(null);

  const [visibleEditorDialog, setVisibleEditorDialog] = useState(false);
  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  // handle ui event section

  const handleOnClickRowEdit = (row) => {
    if (row.id && row.id > 0) {
      row.tanggal = new Date(row.tanggal_transaksi);
      row.jam = new Date(row.tanggal_transaksi);
      row.jam.setHours(row.jam.getHours());
      row.jam.setMinutes(row.jam.getMinutes() + 0);
      row.jam.setSeconds(row.jam.getSeconds() + 0);
    }
    setEditorData(row);
    setVisibleEditorDialog(true);
  };

  const handleOnClickRowDelete = (row) => {
    if (row.id && row.id > 0) {
      setEditorData(row);
      setVisibleDeleteDialog(true);
    }
  };

  const handleOnClickAddNew = () => {
    setEditorData({});
    setVisibleEditorDialog(true);
  };

  const handleOnConfirmedEdit = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorDialog(false);
  };

  const handleOnConfirmedDelete = (data) => {
    listRef.current.handleOnDeleteViewRow(data);
    setVisibleDeleteDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ConfirmDialog />

      <PengisianMinyakDelete
        visible={visibleDeleteDialog}
        onHide={() => setVisibleDeleteDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedDelete}
      />

      <PengisianMinyakEdit
        visible={visibleEditorDialog}
        onHide={() => setVisibleEditorDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEdit}
      />

      <PengisianMinyakList
        ref={listRef}
        onClickRowEdit={handleOnClickRowEdit}
        onClickRowDelete={handleOnClickRowDelete}
        onClickAddNew={handleOnClickAddNew}
      />
    </div>
  );
};

export default PengisianMinyakMain;
